module.exports = __webpack_public_path__ + "static/media/offIcon.af3c0166.svg";